import React from "react";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";

import { nextVarNumber } from "./templatePayload";

/**
 * Botão "+ Inserir variável" — insere {{N}} na posição do cursor de um <textarea>/<input>.
 *
 * Props:
 * - inputRef: ref para o input/textarea Material-UI (acesse com inputRef.current)
 * - value: string atual
 * - onChange: (newValue) => void
 * - max: número máximo de variáveis (default 10 para body, 1 para header)
 * - disabled
 */
const VariableInserter = ({ inputRef, value, onChange, max = 10, disabled, label = "Inserir variável" }) => {
  const handleClick = () => {
    const next = nextVarNumber(value || "");
    if (next > max) return;
    const token = `{{${next}}}`;

    const el = inputRef?.current;
    if (el && typeof el.selectionStart === "number") {
      const start = el.selectionStart;
      const end = el.selectionEnd;
      const newValue =
        (value || "").slice(0, start) + token + (value || "").slice(end);
      onChange(newValue);
      // restaurar foco e posição do cursor
      requestAnimationFrame(() => {
        try {
          el.focus();
          const pos = start + token.length;
          el.setSelectionRange(pos, pos);
        } catch (_) {}
      });
    } else {
      onChange((value || "") + token);
    }
  };

  return (
    <Button
      type="button"
      size="small"
      variant="outlined"
      color="primary"
      onClick={handleClick}
      disabled={disabled || nextVarNumber(value || "") > max}
      startIcon={<AddIcon />}
      style={{ textTransform: "none" }}
    >
      {label}
    </Button>
  );
};

export default VariableInserter;
